export default __webpack_public_path__ + "static/media/2 siit-logo.02a2ab01.png";